import Vue from 'vue'
import { store } from '@/app/store'

export const EndCardAPI = {
    getTemplatePackhot: async function (selectedPackshot, size) {
        return await Vue.axios
            .post(
                "/packshots/getLottiesPackshots",
                {
                    sessionId: store.state.userInfo.sessionId,
                    id: selectedPackshot.packId,
                    size: size,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                }
            )
    }
}